import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=7784579a&scoped=true&"
import script from "./BrandLogo.vue?vue&type=script&lang=js&"
export * from "./BrandLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7784579a",
  null
  
)

export default component.exports